import { Box, Paper, Stack } from '@mui/material';
import React, { useCallback } from 'react';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import 'survey-core/defaultV2.min.css';
import { Button, WsColors } from 'wisestep-base';

import SubmissionCandidateEvalutationView from '../../features/conversationWidget/components/SubmissionCandidateEvalutationView';

import { themeJSON } from './theme';

interface SurveyFeedbackProps {
  feedbackDataBack?: (que: any, ans: any) => void;
  callShowBackInfoList?: () => void;
  surveyJson: any;
  isEditMode: boolean;
  responseData?: any;
  survayResponse?: boolean;
  showBackButton?: boolean;
}

const SurveyInfoByJobComponent: React.FC<SurveyFeedbackProps> = ({
  feedbackDataBack,
  callShowBackInfoList,
  surveyJson,
  responseData,
  survayResponse,
  showBackButton = true,
}) => {
  const survey = new Model(surveyJson);

  survey.widthMode = 'responsive';
  survey.applyTheme(themeJSON);
  const isSurveyEmpty = Object.keys(survey.data).length === 0;
  survey.mode = isSurveyEmpty ? 'edit' : 'display';

  const handleSurveyComplete = useCallback(() => {
    const feedbackData = {};
    let elementList: any[] = [];

    if (surveyJson.pages.length > 1) {
      surveyJson.pages.map((page, pageIndex) => {
        page.elements.map((_, elementIndex) => {
          elementList.push(surveyJson.pages[pageIndex].elements[elementIndex]);
        });
      });
    } else {
      elementList = surveyJson.pages[0].elements;
    }
    for (const key in survey.data) {
      const question = survey.getQuestionByName(key);
      if (question) {
        feedbackData[question.title] = question.value;
      }
    }
    feedbackDataBack?.(elementList, feedbackData);
  }, [feedbackDataBack, surveyJson.pages, survey]);
  survey.onComplete.add(handleSurveyComplete);

  const handleBackButtonClick = () => {
    callShowBackInfoList?.();
  };

  return (
    <>
      <Stack sx={{ backgroundColor: WsColors.White, p: 2 }}>
        {showBackButton && (
          <Button
            variant="contained"
            onClick={handleBackButtonClick}
            sx={{ alignSelf: 'flex-end' }}
          >
            Back to list
          </Button>
        )}
        <Box flexGrow={1} style={{ maxHeight: '700px', overflowY: 'auto' }}>
          {survayResponse ? (
            <SubmissionCandidateEvalutationView feedbackResponseData={responseData} />
          ) : (
            <Paper variant="outlined" sx={{ borderRadius: 2, p: 2.5, mt: 3 }}>
              <Survey model={survey} />
            </Paper>
          )}
        </Box>
      </Stack>
    </>
  );
};

export default SurveyInfoByJobComponent;
